/* @ngInject */
const sterileResource = (
  $resource,
  paths
) => {
  const path = `${paths.handlers.sterile}/:action`

  return $resource(
    path,
    { action: '@action' }, {
    'update': {
      method: 'PUT',
    },
    'query': {
      method: 'GET',
    },
    'get': {
      method: 'GET',
      isArray: false,
    },
    'post': {
      method: 'POST',
    },
  })
}
export default sterileResource



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sterile/services/resource.service.js